import {Card, FC, MouseEventHandler} from 'external/react'
import Icon from 'external/fortawesome' 
import usePackage from 'context/package-context/hook'

type PackageItemHeaderProps = {
    id: string
    index: number
    alias: string
}

const PackageItemHeader : FC<PackageItemHeaderProps> = props => {
    const {alias, id, index} = props
	const {update} = usePackage()

    function handleEditClick() {
        update({modals: {changePackageAlias: {open: {$set: true}, index: {$set: index}, id: {$set: id}, plan_alias: {$set: alias}}}})    
    }

    return (
        <Card.Header className='bg-white d-flex justify-content-between'>
            <span className='fw-bold'>{alias}</span>
            <span className='span--edit' title='editar' onClick={handleEditClick}>
                <Icon name='faPenToSquare' />
            </span>
        </Card.Header>
    )
}

export {PackageItemHeader as default}